var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"border-b border-gray-200 hover:bg-gray-100",on:{"click":function($event){return _vm.$emit('click', $event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }